import React from "react";

import { Icon, IconProps } from "@cobasi/ds-icons";

import type { ActionProps } from "./actions.types";

import s from "./action.module.scss";

const Action = ({
  label,
  icon,
  className = "link-lemon",
  wrapperClassName,
  iconProps,
  onClick
}: ActionProps) => {
  return (
    <div className={`${s.buttons} ${wrapperClassName}`}>
      <button
        className={`link ${className}`}
        aria-label={label}
        onClick={onClick}
      >
        {icon && (
          <Icon
            className="link-icon-left"
            data-testid="icon"
            {...(iconProps as IconProps)}
            icon={icon as IconProps["icon"]}
          />
        )}
        <span>{label}</span>
      </button>
    </div>
  );
};

export default Action;
